var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Ekspertiz Bilgisi"}},[_c('b-list-group',_vm._l((_vm.swapcar.expertise),function(item,key){return _c('list-item',{key:key,attrs:{"title":_vm.getValue(key,item).title,"value":_vm.getValue(key,item).value}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }